import { Vector3 } from "../../../maths/Vector3";
import { BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../../../RenderEngine/RenderEnum/RenderPologyMode";
import { VertexMesh } from "../../../RenderEngine/RenderShader/VertexMesh";
import { BufferState } from "../../../webgl/utils/BufferState";
import { Bounds } from "../../math/Bounds";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { GeometryElement } from "../GeometryElement";
export class UI3DGeometry extends GeometryElement {
    constructor(owner) {
        super(MeshTopology.Triangles, DrawType.DrawElement);
        this._owner = owner;
        this.bufferState = new BufferState();
        this._bound = new Bounds();
        this._createBuffer();
        this.indexFormat = IndexFormat.UInt16;
    }
    get bounds() {
        return this._bound;
    }
    _createBuffer() {
        var vertexDeclaration = VertexMesh.getVertexDeclaration("POSITION,NORMAL,UV");
        var halfLong = 1 / 2;
        var halfWidth = 1 / 2;
        this._vertex = new Float32Array([-halfLong, halfWidth, 0, 0, 0, 1, 0, 0,
            halfLong, halfWidth, 0, 0, 0, 1, 1, 0,
            -halfLong, -halfWidth, 0, 0, 0, 1, 0, 1,
            halfLong, -halfWidth, 0, 0, 0, 1, 1, 1]);
        this._index = new Uint16Array([0, 1, 2, 3, 2, 1]);
        this._vertexBuffer = Laya3DRender.renderOBJCreate.createVertexBuffer3D(this._vertex.length * 4, BufferUsage.Dynamic, false);
        this._vertexBuffer.vertexDeclaration = vertexDeclaration;
        this._vertexBuffer.setData(this._vertex.buffer);
        this._indexBuffer = Laya3DRender.renderOBJCreate.createIndexBuffer3D(IndexFormat.UInt16, this._index.length, BufferUsage.Static, false);
        this._indexBuffer.setData(this._index);
        this.bufferState = new BufferState();
        this.bufferState.applyState([this._vertexBuffer], this._indexBuffer);
        this._bound.setExtent(new Vector3(halfLong, halfWidth, halfLong));
        this._bound.setCenter(new Vector3(0, 0, 0));
        this._positionArray = [new Vector3(), new Vector3(), new Vector3(), new Vector3()];
        this._positionArray[0].set(-halfWidth, halfLong, 0.0);
        this._positionArray[1].set(halfWidth, halfLong, 0.0);
        this._positionArray[2].set(-halfWidth, -halfLong, 0.0);
        this._positionArray[3].set(halfWidth, -halfLong, 0.0);
    }
    _updateRenderParams(state) {
        this.clearRenderParams();
        this.setDrawElemenParams(6, 0);
    }
    destroy() {
        super.destroy();
        this.bufferState.destroy();
        this._vertexBuffer.destroy();
        this._indexBuffer.destroy();
        this.bufferState = null;
        this._vertexBuffer = null;
        this._indexBuffer = null;
        delete this._vertex;
        delete this._index;
    }
}
UI3DGeometry._type = GeometryElement._typeCounter++;
const tempV0 = new Vector3();
